import { create } from 'zustand'
import type { EditorPosition, EditorSelection } from '../types'

interface EditorStore {
  content: string
  cursor: EditorPosition
  selection: EditorSelection | null
  isModified: boolean
  insertText: ((text: string) => void) | null
  wrapSelection: ((before: string, after: string) => void) | null
  setContent: (content: string) => void
  setCursor: (cursor: EditorPosition) => void
  setSelection: (selection: EditorSelection | null) => void
  setIsModified: (modified: boolean) => void
  setEditorActions: (actions: { insertText: (text: string) => void; wrapSelection: (before: string, after: string) => void }) => void
  getWordCount: () => number
  getLineCount: () => number
  getCharCount: () => number
}

export const useEditorStore = create<EditorStore>((set, get) => ({
  content: `# Welcome to Markdown Editor\n\nThis is a **modern** web-based Markdown editor.\n\n## Features\n\n- Real-time preview\n- Syntax highlighting\n- Dark/Light theme\n- File management\n\n## Code Example\n\n\`\`\`javascript\nfunction hello() {\n  console.log("Hello, World!");\n}\n\`\`\`\n\n## Table\n\n| Feature | Status |\n|---------|--------|\n| Editor  | ✅     |\n| Preview | ✅     |\n| Theme   | ✅     |\n\n> Start editing to see the preview update in real-time!\n`,
  cursor: { line: 1, column: 1 },
  selection: null,
  isModified: false,
  insertText: null,
  wrapSelection: null,
  setContent: (content) => set({ content, isModified: true }),
  setCursor: (cursor) => set({ cursor }),
  setSelection: (selection) => set({ selection }),
  setIsModified: (modified) => set({ isModified: modified }),
  setEditorActions: (actions) => set({ insertText: actions.insertText, wrapSelection: actions.wrapSelection }),
  getWordCount: () => {
    const content = get().content
    const text = content.replace(/[#*`\[\]()>|-]/g, ' ').trim()
    return text ? text.split(/\s+/).length : 0
  },
  getLineCount: () => get().content.split('\n').length,
  getCharCount: () => get().content.length,
}))
